import { useTranslations } from "next-intl";
import { useState } from "react";

import { KikReviewsV2Media, KikReviewsV2ResponseReviewItem } from "~/shared/power-reviews-response.interface";
import prUtils from "~/utils/power-reviews-utils";

import styles from "./review-item.module.scss";
import ReviewItemText from "./review-item-text";
import ReviewsGalleryDialog from "./reviews-gallery-dialog";

type PropsProductReviews = {
  review: KikReviewsV2ResponseReviewItem;
};

export default function ReviewItem(props: PropsProductReviews) {
  const t = useTranslations();
  const { review } = props;
  const [startingIdForGallery, setStartingIdForGallery] = useState<string>();
  const media = review.media;

  // const media = [
  //   {
  //     id: "581436027",
  //     review_id: 581436026,
  //     uri: "//res.cloudinary.com/powerreviews/image/upload/f_auto,q_auto,h_768,w_auto/d_portal-no-product-image_ttlfpi.svg/prod/w3mkznzrpkiw6qgwskhi.jpg",
  //     headline: "Angenehmes Tragegefühl und schöne Farbe",
  //     rating: 5,
  //     helpful_votes: 0,
  //     not_helpful_votes: 0,
  //     type: "image",
  //     caption: "Angenehme Textur",
  //     nickname: "Angelina",
  //     created_date: 1780512985761,
  //   },
  //   {
  //     id: "581435992",
  //     review_id: 581436026,
  //     uri: "//res.cloudinary.com/powerreviews/image/upload/f_auto,q_auto,h_768,w_auto/d_portal-no-product-image_ttlfpi.svg/prod/btqzywtgxof6uxthyizq.jpg",
  //     headline: "Angenehmes Tragegefühl und schöne Farbe",
  //     rating: 5,
  //     helpful_votes: 0,
  //     not_helpful_votes: 0,
  //     type: "image",
  //     caption: "Wunderschöner Farbton",
  //     nickname: "Angelina",
  //     created_date: 1780512985761,
  //   },
  // ] as KikReviewsV2Media[];

  const onImageClick = (id: string) => {
    setStartingIdForGallery(id);
  };

  return (
    <div className={styles.reviewItem} role="group" aria-label={t("generic.review")}>
      {media.length > 0 && (
        <div className={styles.reviewItemImages}>
          {media.map((m, i) => {
            return (
              <figure role="button" aria-label={t("a11y.galleryButton")} key={m.id} onClick={() => onImageClick(m.id)}>
                <picture>
                  <source type="image/webp" srcSet={prUtils.getThumbnail(m.uri, "webp")}></source>
                  <source type="image/jxr" srcSet={prUtils.getThumbnail(m.uri, "jxr")}></source>
                  <img
                    alt={t("a11y.userSubmittedMedia", { index: i + 1, total: media.length })}
                    aria-describedby={`review-headline-${m}`}
                    src={prUtils.getThumbnail(m.uri)}
                  />
                </picture>
                <figcaption>{m.caption}</figcaption>
              </figure>
            );
          })}
          {startingIdForGallery && (
            <ReviewsGalleryDialog
              onClose={() => setStartingIdForGallery(undefined)}
              startingIdForGallery={startingIdForGallery}
              media={media}
              review={review}
            />
          )}
        </div>
      )}
      <ReviewItemText review={review} />
    </div>
  );
}
